import { END_IMPERSONATION_TOOLTIP, START_IMPERSONATION } from "../action_types/impersonate_action_types";

export const startImpersonation = (showTooltip: boolean) => {
    return {
        type: START_IMPERSONATION,
        showTooltip,
    };
};

const endImpersonationTooltip = () => {
    return {
        type: END_IMPERSONATION_TOOLTIP,
    };
};
